import { TrialResultQuery } from "@generated/graphql";
import { Stack } from "@mui/material";
import ScrollTopButton from "components/ScrollTopButton";
import getTrialAnswerList from "../../helpers/getTrialAnswerList";
import CollapsedBlock from "../CollapsedBlock";
import CandidateAnswer from "./CandidateAnswer";

interface CandidateAnswersProps {
  trial: NonNullable<TrialResultQuery["trial"]>;
}

const CandidateAnswers = ({ trial }: CandidateAnswersProps) => {
  const knowledgeBlocks = trial.examination.competencyMap.competences;

  const answers = getTrialAnswerList(knowledgeBlocks);

  return (
    <CollapsedBlock title='Ответы кандидата'>
      <Stack spacing={2}>
        {answers?.map((answer) => (
          <CandidateAnswer
            key={`answer-${answer.id}`}
            trial={trial}
            answer={answer}
          />
        ))}
      </Stack>
      <ScrollTopButton />
    </CollapsedBlock>
  );
};

export default CandidateAnswers;
